import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      // Logged in already: go to the home page (the default dashboard, or the first permitted page)
      this.router.navigate(['/home']);
      return false; // Prevent access to the login page
    }
    return true; // Allow access to the login page if not authenticated
  }
}
